import { ShowTagScreen, ShowTagScreenProps } from 'shared/screens/blog/show-tag';
import { withServerProps } from '@web/library/with-server-props';
import { Page } from '@web/components/page';
import { useTranslation } from 'react-i18next';

const MIN_TAG_META_DESCRIPTION_LENGTH = 100;

export default function ShowTag(props: ShowTagScreenProps) {
  const { t } = useTranslation('screens');
  const description = props.tag.description.trim();
  const metaDescription =
    description.length >= MIN_TAG_META_DESCRIPTION_LENGTH
      ? description
      : t('blog.show_tag.meta_description', {
          tag: props.tag.name,
          description,
        });

  return (
    <Page
      {...props}
      register={(seo) => seo.setTitle(props.tag.name).setDescription(metaDescription)}
    >
      <ShowTagScreen {...props} />
    </Page>
  );
}

export const getServerSideProps = withServerProps(ShowTagScreen.pageBuilder);
